<template>
    <div>
        <div class="grid-news-first  mx-n3 mb-3"
             ref="lazyLoadWrap"
             v-images-loaded:on.done="layout" :list="list">

            <div class="grid-item" v-for="element in list">
                <div class="wrapper-white">
                    <a :href="element.url">
                        <img v-if="element.image"
                             :src="element.image"
                             :alt="element.name">
                    </a>
                    <div class="p-3 position-relative">
                        <a :href="element.url">
                            <span class="status-job -event"
                                  :style="{backgroundColor:element.badge.color}"
                                  v-if="undefined !== element.badge && null !== element.badge && undefined !== element.badge.content">
                                    {{element.badge.content}}
                            </span>
                            <h5 :class="{'text-center':isOffers}">{{element.name}}</h5>
                            <span class="data-sale-cart"
                                  v-if="isOffers">
                                {{element.date}}
                            </span>
                            <template v-if="isOffers">
                                <p class="text-center"
                                   v-if="element.tenant && element.tenant.name">{{element.tenant.name}} </p>
                            </template>
                            <p v-else>{{element.excerpt}} </p>
                        </a>
                        <div class="clearfix mt-3"
                             v-if="false==isOffers">
                            <a :href="element.url"
                               class="link-orange float-right">{{element.read_more}}</a>
                            <!--<div class="data-add float-left"
                                 v-if="undefined !== element.badge && null !== element.badge && undefined !== element.badge.content">
                                {{element.badge.content}}
                            </div>-->
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="loader" v-if="firstLoader">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                 preserveAspectRatio="xMidYMid" class="lds-double-ring">
                <circle cx="50" cy="50"
                        fill="none"
                        stroke-linecap="round"
                        r="40"
                        :stroke="strokeColor"
                        stroke-width="4"
                        stroke-dasharray="62.83185307179586 62.83185307179586"
                        transform="rotate(107.463 50 50)">
                    <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                      values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                                      repeatCount="indefinite"></animateTransform>
                </circle>
                <circle cx="50" cy="50"
                        :stroke="strokeColor"
                        fill="none"
                        stroke-linecap="round"
                        r="35"
                        stroke-width="4"
                        stroke-dasharray="54.97787143782138 54.97787143782138"
                        stroke-dashoffset="54.97787143782138"
                        transform="rotate(-107.463 50 50)">
                    <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                      values="0 50 50;-360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                                      repeatCount="indefinite"></animateTransform>
                </circle>
            </svg>
        </div>
    </div>
</template>

<script>
    import imagesLoaded from 'vue-images-loaded'
    import axios from 'axios'

    export default {
        name: "NewsList",
        directives: {
            imagesLoaded,
        },
        data() {
            return {
                onProgress: false,
                emptyData: false,
                gridSelector: '.grid-news-first',
                itemSelector: '.grid-item',
                url: document.getElementById('newsWrap').dataset.apiUrl,
                type: document.getElementById('newsWrap').dataset.type,
                strokeColor: document.getElementById('newsWrap').dataset.shopColor,
                lang: 'pl',
                num: 10,
                page: 1,
                list: [],
                msnry: null,
                firstLoader: true
            }
        },
        computed: {
            isOffers() {
                if (1 == this.type) {
                    return true;
                }
                return false;
            }
        },
        methods: {
            layout() {
                let self = this;
                let grid = document.querySelector(self.gridSelector);
                /*if (true === this.ready) {
                    this.msnry.reloadItems();
                    this.cntHeight();
                    return;
                }*/
                this.msnry = new Masonry(grid, {
                    itemSelector: self.itemSelector
                });
                /*      setTimeout(() => {
                          self.ready = true;
                      }, 600)
                      */
                this.cntHeight();
                // this.showLoader = false
            },
            setNextPage() {
                this.page += 1;
            },
            getElements() {
                if (true === this.onProgress || true === this.emptyData) {
                    return;
                }
                this.onProgress = true;
                axios({
                    url: this.url,
                    method: 'GET',
                    params: {
                        page: this.page,
                        num: this.num,
                        lang: this.lang,
                    }
                }).then(response => {
                    if (200 !== response.status) {
                        console.log('-----error-------');
                        return;
                    }
                    let newElements = response.data;
                    let lengthOfNew = Object.keys(newElements).length;
                    if (this.num > lengthOfNew) {
                        this.emptyData = true;
                    }

                    for (let i = 0; i < lengthOfNew; i++) {
                        let currentKey = Object.keys(newElements)[i];
                        this.list.push(newElements[currentKey])
                    }

                    this.layout();

                    this.firstLoader = false
                    this.onProgress = false;
                }).catch(error => {
                    console.log('-----error-------');
                    this.getElements();
                });
            },
            cntHeight() {
                if (true === this.onProgress || true === this.emptyData) {
                    return;
                }
                let wrap = this.$refs.lazyLoadWrap;
                if (undefined === wrap || null === wrap) {
                    return false;
                }

                let height = wrap.clientHeight;
                if (0 === height) {
                    return false;
                }
                let offsetTop = wrap.offsetTop;

                let windowHeight = window.innerHeight + Math.round(window.innerHeight / 3);

                if (parseFloat(windowHeight) > parseFloat(height) + parseFloat(offsetTop)) {
                    this.setNextPage();
                    return true;
                }

                let pageYOffset = window.pageYOffset;
                if (windowHeight + pageYOffset > height + offsetTop) {
                    this.setNextPage();
                    return true;
                }

                return false;
            }
        },
        watch: {
            'page'() {
                this.getElements();
            }
        },
        created() {
            this.lang = document.documentElement.lang;
            this.getElements();
            window.addEventListener('scroll', (e) => {
                this.cntHeight();
            })
        },
    }
</script>

<style scoped>
    .data-sale-cart {
        text-align: center;
        font-weight: 900;
        color: #ec6723;
        font-size: 12px;
        padding-bottom: 5px;
        display: block;
    }

    .loader {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, .6);
        text-align: center;
        padding-top: 60px;
        position: fixed;
        top: 0;
    }

    .loader svg {
        vertical-align: baseline;
        width: 100px;
        height: 100px;
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue